export default __webpack_public_path__ + "static/media/Blue-Android-4.68d06270.png";